module.exports = "clear-button"